export default "__VITE_ASSET__DZqQ28dV__"